import {Component, OnInit} from '@angular/core';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {QFilterModel} from '../../../../models/qfilter.model';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {IndicatorsService} from '../../../../services/indicators/indicators.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-analysis-single-store-overview',
  templateUrl: './analysis-single-store-overview.component.html',
  styleUrls: ['./analysis-single-store-overview.component.css']
})
export class AnalysisSingleStoreOverviewComponent implements OnInit {

  public data: QFilterModel;

  public indicators: IndicatorBoxModel[] = [];
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public storeInfo: {
    area: string;
    canale: string;
    codice_negozio: any;
    data_apertura: string;
    data_chiusura: string;
    descrizione: string;
    insegna: string;
    parita: string;
    superficie: string;
  };

  public storeInfoDesc: string[] = [];

  public storeError = false;
  public selectOneError: string;

  constructor(
    private translate: TranslateService,
    private indicatorService: IndicatorsService,
  ) { }

  ngOnInit() {
    this.storeInfo = {
      area: '',
      canale: '',
      codice_negozio: '',
      data_apertura: '',
      data_chiusura: '',
      descrizione: '',
      insegna: '',
      parita: '',
      superficie: ''
    };

    this.translate.get([
      'stores.descrizione',
      'stores.superficie',
      'stores.area',
      'stores.insegna',
      'stores.canale',
      'stores.data_apertura',
      'stores.data_chiusura',
      'stores.parita',
      'stores.note'
    ]).subscribe(t => {
      this.storeInfoDesc = t;
    });

    this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;
    if (data['stores'] != null) {
      this.translate.get([
        'indicator.fatturato',
        'indicator.scontrini',
        'indicator.fatturato_mq',
        'indicator.scontrino_medio',
        'indicator.media_clienti_settimanali',
        'indicator.incidenza_carta',
        'indicator.incidenza_promo',
        'indicator.nuovi_clienti',
      ]).subscribe(t => {
        this.indicators = [];


        this.indicatorService.getStorePost(this.data).switchMap((res) => {
          this.storeInfo.descrizione = res.descrizione;
          this.storeInfo.superficie = res.superficie;
          this.storeInfo.area = res.area;
          this.storeInfo.insegna = res.insegna;
          this.storeInfo.canale = res.canale;
          this.storeInfo.data_apertura = res.data_apertura;
          this.storeInfo.data_chiusura = res.data_chiusura;
          this.storeInfo.parita = res.parita;

          console.log('q076', res);

          return this.indicatorService.indicatorCalculation('stores.Q077', this.data);
        }).switchMap((res) => {
          console.log('Q077', res);

          this.indicators.push(new IndicatorBoxModel([res[0]], {dynamic: true, decimal_value: 2, unit_period_prec: res[0].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[1]], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: res[1].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[2]], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: res[2].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[3]], {decimal_value: 2, unit_period_prec: res[3].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[4]], {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: res[4].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[5]], {decimal_value: 2, unit_period_prec: res[5].unitOfMeasure}, t));
          this.indicators.push(new IndicatorBoxModel([res[6]], {decimal_value: 2, unit_period_prec: res[6].unitOfMeasure}, t));


          return this.indicatorService.indicatorCalculation('stores.Q084', this.data);
        }).subscribe((res) => {
          console.log('Q084', res);
          this.indicators.push(new IndicatorBoxModel([res[0]], {decimal_value: 0, decimal_prec_value: 0}, t));
        });
      });
    } else {
      this.data = null;
      this.storeError = true;
    }
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public resetData() {
    this.data = null;
    this.indicators = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store/analysis-single-store-overview.component.ts